import React, { useState } from 'react';
import axios from 'axios';

function ContactContent() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    // Form validation function
    function validateForm() {
        if (!name || !email || !message) {
            alert("Kindly fill all the fields!");
            return false;
        }
        return true;
    }

    const submitForm = async () => {
        let fData = new FormData();
        fData.append('name', name);
        fData.append('email', email);
        fData.append('message', message);

        try {
            //const response = await axios.post('http://localhost/cfiitm/contact.php', fData, {
        const response = await axios.post('https://acr.iitm.ac.in/cfiitm/contact.php', fData, {
                headers: { 'Content-Type': "multipart/form-data" }
            });

            if (response.data.message === 'Form submitted successfully!') {
                alert("Form submitted successfully!");
                // Clear form fields after successful submission
                setName('');
                setEmail('');
                setMessage('');
            } else {
                alert('Kindly fill all the fields!');
            }
        } catch (error) {
            console.error('Error during form submission:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            await submitForm();
        }
    };

    return (
        <>
            <div className="form-main">
                <div className="main-wrapper">
                    <h2 className="form-head">Contact Us</h2>
                    <form className="form-wrapper" onSubmit={handleSubmit}>
                        <div className="form-card">
                            <input
                                className="form-input"
                                type="text"
                                name="full_name"
                                id="full_name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                            <label className="form-label" htmlFor="full_name">Full Name</label>
                        </div>
                        <div className="form-card">
                            <input
                                className="form-input"
                                type="email"
                                name="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <label className="form-label" htmlFor="email">Email</label>
                        </div>
                        <div className="form-card">
                            <textarea
                                className="form-textarea"
                                maxLength="420"
                                rows="3"
                                name="message"
                                id="message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                            />
                            <label className="form-textarea-label" htmlFor="message">Message</label>
                        </div>
                        <div className="btn-wrap">
                            <button type="submit">SUBMIT</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default ContactContent;
